import Hero from "./components/Hero";
import Services from "./components/Services";
import ExoticShowcase from "./components/ExoticShowcase";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import ContactCTA from "./components/ContactCTA";

export default function Home() {
  return (
    <main>
      <Hero />
      <Services />
      <ExoticShowcase />
      <WhyChooseUs />
      <Testimonials />
      <ContactCTA />
    </main>
  );
}
